module.exports = "/templates/bds/public/images/277706fedcf440dfa9fd535ef7285c82.svg";